import React, { useEffect, useState } from 'react';
import { FormComponentProps } from '@ant-design/compatible/lib/form';
import { Element } from 'react-scroll';

import RadioGroupForm from '../../../../components/form/RadioGroupForm';
import ColorInputForm from './component/ColorInputForm';
import InputForm from '../../../../components/form/InputForm';
import { formRequiredRules } from '../../../../lib/formRules';
import { REX_COLOR_HEXA_CODE } from '../../../../lib/rex';
import { EventDetailColorSet } from '../../../../types/query/event/detail';
import {
  EVENT_TAB_COLOR_STATUS_SELECT_LIST,
  MAXIMUM_NUMBER_OF_EVENT_SECTION_COLOR_SET_TEXT,
} from '../../../../constants/service/app/eventConstants';
import { REQUIRED_MSG } from '../../../../constants/service/common/formRulesConstants';
import './EventColorSet.scss';

interface EventColorSetProps extends FormComponentProps {
  colorSet?: EventDetailColorSet;
}
const EventColorSet = (props: EventColorSetProps) => {
  const { form, colorSet } = props;
  const isDefaultColor = form.getFieldValue('isDefaultColor') ?? colorSet?.isDefaultColor;
  const [sectionTabBackgroundColor, setSectionTabBackgroundColor] = useState(colorSet?.sectionTabBackgroundColor);
  const [sectionTabActiveColor, setSectionTabActiveColor] = useState(colorSet?.sectionTabActiveColor);
  const [sectionTabInactiveColor, setSectionTabInactiveColor] = useState(colorSet?.sectionTabInactiveColor);

  useEffect(() => {
    setSectionTabBackgroundColor(colorSet?.sectionTabBackgroundColor);
    setSectionTabActiveColor(colorSet?.sectionTabActiveColor);
    setSectionTabInactiveColor(colorSet?.sectionTabInactiveColor);
  }, [colorSet]);

  const handleChangeIsDefaultColor = (data: boolean) => {
    if (data) return;
    setSectionTabBackgroundColor('');
    setSectionTabActiveColor('');
    setSectionTabInactiveColor('');
  };

  return (
    <Element name="event-color-set">
      <div className="event-color-set">
        <div className="title">기획전 섹션 이동 탭 옵션</div>

        <RadioGroupForm
          form={form}
          initialValue={colorSet?.isDefaultColor ?? true}
          list={EVENT_TAB_COLOR_STATUS_SELECT_LIST}
          name="isDefaultColor"
          label="섹션 이동 탭 색상"
          rules={[formRequiredRules(true, REQUIRED_MSG, false)]}
          onChange={handleChangeIsDefaultColor}
        />

        {isDefaultColor === false ? (
          <div className="section-tab-color-input-wrap">
            <ColorInputForm
              name="sectionTabBackgroundColor"
              form={form}
              label="탭 배경"
              initialValue={sectionTabBackgroundColor}
              maxLength={MAXIMUM_NUMBER_OF_EVENT_SECTION_COLOR_SET_TEXT}
              rules={[
                formRequiredRules(true, REQUIRED_MSG, false),
                {
                  pattern: REX_COLOR_HEXA_CODE,
                  message: '올바른 색상 헥스 코드를 입력해주세요.\nex) #FFFFFF',
                },
              ]}
            />
            <ColorInputForm
              name="sectionTabActiveColor"
              form={form}
              label="선택된 타이틀"
              initialValue={sectionTabActiveColor}
              maxLength={MAXIMUM_NUMBER_OF_EVENT_SECTION_COLOR_SET_TEXT}
              rules={[
                formRequiredRules(true, REQUIRED_MSG, false),
                {
                  pattern: REX_COLOR_HEXA_CODE,
                  message: '올바른 색상 헥스 코드를 입력해주세요.\nex) #FFFFFF',
                },
              ]}
            />
            <ColorInputForm
              name="sectionTabInactiveColor"
              form={form}
              label="미선택 타이틀"
              initialValue={sectionTabInactiveColor}
              maxLength={MAXIMUM_NUMBER_OF_EVENT_SECTION_COLOR_SET_TEXT}
              rules={[
                formRequiredRules(true, REQUIRED_MSG, false),
                {
                  pattern: REX_COLOR_HEXA_CODE,
                  message: '올바른 색상 헥스 코드를 입력해주세요.\nex) #FFFFFF',
                },
              ]}
            />
            <InputForm form={form} type="hidden" name="colorSetId" initialValue={colorSet?.id} />
          </div>
        ) : null}
        <div className="sub-content">
          <div>
            *‘기본 색상' 옵션 선택 시, 기본으로 설정된 색이 자동 반영됩니다. 특정 색상으로 수정하고 싶을 때에만 ‘색상
            변경' 옵션을 선택해주세요.
          </div>
          <div>* 기본 색상: [탭 배경]#FFFFFF(흰색) [선택된 타이틀]#000000(검정색) [미선택 타이틀]#9B9B9B(회색)</div>
          <div>*헥스 코드 양식으로 입력해주세요. ex)#FFFFFF</div>
        </div>
      </div>
    </Element>
  );
};

EventColorSet.displayName = 'EventColorSet';

export default EventColorSet;
